import { render, staticRenderFns } from "./appSvg.vue?vue&type=template&id=264abe37"
import script from "./appSvg.vue?vue&type=script&lang=js"
export * from "./appSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports